import React, { useState, useCallback, useEffect } from "react";
import {
  TextField,
  MenuItem,
  Grid,
  Paper,
  Typography,
  Autocomplete,
  Button,
  Box,
  FormControlLabel,
  Checkbox,
  Chip,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import axios from "axios";
import debounce from "lodash/debounce";
import { API_URL } from "../../utils/apiUtils";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  fetchFullGroupCollectionByIdService,
  updateGroupCollectionsService,
} from "../../services/groupService";

function GroupCollection() {
  const [isSubmit, setIsSubmit] = useState(false);
  const date = new Date().toISOString().split("T")[0];
  const [hasPaidLoan, setHasPaidLoan] = useState(false);
  const formik = useFormik({
    initialValues: {
      loan: "",
      agentName: "",
      frequency: "",
      totalLoanAmount: "",
      totalReceivedAmount: Number,
      remainingAmount: Number,
      collectionAmount: "",
      interestAmount: "",
      totalInterestPaid: "",
      amountToBePaidBy: "",
      dueDate: null,
      collectionDate: date,
      paidAmount: "",
      selectedUserData: [],
    },
    validationSchema: Yup.object({
      loan: Yup.string().required("Loan is required"),
      collectionAmount: Yup.number().required("Collection amount is required"),
      collectionDate: Yup.date().required("CollectionDate Required"),
      selectedUserData: Yup.array(),
    }),
    onSubmit: async (values) => {
      try {
        if (values.selectedUserData.length === 0) {
          toast.error("Select One Colletion");
        } else {
          setIsSubmit(true);
          const updateLoanCollection = await updateGroupCollectionsService(
            groupCollection?._id,
            values.amountToBePaidBy,
            values.collectionDate,
            values.interestAmount,
            values.paidAmount,
            values.selectedUserData
          );
          toast.success("Loan collected successfully");
          navigate("/group");
        }
      } catch (error) {
        setIsSubmit(false);
        toast.error(error.message);
      }
    },
  });
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [groupCollection, setGroupCollection] = useState();

  const [loans, setLoans] = useState([]);
  const token = sessionStorage.getItem("accessToken");
  const calculateAmountBasedOnType = (loan, type) => {
    switch (type) {
      case "emi":
        return loan.collectionAmount;
      case "penalty":
        return loan?.penaltyAmount;
      case "interest":
        return loan?.interestAmount; // Logic for custom payment can be added
      default:
        return loan.collectionAmount;
    }
  };

  const [selectedUsers, setSelectedUsers] = useState([]);

  const handleCheckboxChange = (userId, setFieldValue, collectionAmount) => {
    setSelectedUsers(
      (prevSelected) =>
        prevSelected.includes(userId?._id)
          ? prevSelected.filter((id) => id !== userId?._id) // Remove if already selected
          : [...prevSelected, userId?._id] // Add if not selected
    );
    selectedUsers.includes(userId?._id)
      ? console.log(selectedUsers.length - 1)
      : console.log(selectedUsers.length + 1);
    let count;
    let amount;
    if (selectedUsers.includes(userId?._id)) {
      count = selectedUsers.length - 1;
      if (count != 0) {
        amount = collectionAmount * count;
        return amount;
      } else {
        amount = 0;
        return 0;
      }
    } else {
      count = selectedUsers.length + 1;
      amount = collectionAmount * count;
      return amount;
    }
  };
  // Handle "Select All" checkbox change
  const handleSelectAllChange = (event) => {
    if (event.target.checked) {
      // Select all users
      const allUserData = loans
        .map((loan) => {
          if (loan.user?._id) {
            return {
              id: loan.user._id,
              amountToBePaidType: "emi", // Default type
              amount: loan.collectionAmount, // Default amount
              interestAmount: loan.interestAmount,
            };
          }
          return null; // Filter out invalid users
        })
        .filter(Boolean); // Ensure valid user data

      formik.setFieldValue("selectedUserData", allUserData);
    } else {
      // Deselect all users
      formik.setFieldValue("selectedUserData", []);
    }
  };

  // Determine if all users are selected
  const allSelected =
    formik.values.selectedUserData.length === loans.length && loans.length > 0;

  const fetchOptions = async (query) => {
    if (!query) return;
    setLoading(true);
    try {
      const response = await axios.get(
        `${API_URL}/group/search-group-collection`,
        {
          params: { searchQuery: query },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setOptions(response.data.groups);
    } catch (error) {
      console.error("Error fetching options:", error);
    }
    setLoading(false);
  };

  const debouncedFetchOptions = useCallback(
    debounce((query) => {
      fetchOptions(query);
    }, 300),
    []
  );
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, "0"); // Ensure 2 digits
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleAutocompleteChange = async (event, newValue, setFieldValue) => {
    setFieldValue("loan", newValue ? newValue._id : "");
    const fetchLoan = await fetchFullGroupCollectionByIdService(newValue._id);
    setGroupCollection(fetchLoan?.groupCollection);
    setLoans(fetchLoan?.loans);
    const hasPaidLoan = fetchLoan.loans.some((loan) => loan.status === "paid");

    // Update state based on the result
    setHasPaidLoan(hasPaidLoan);
    const formattedDueDate = formatDate(fetchLoan?.groupCollection?.dueDate);
    if (fetchLoan.status === "partial") {
      const amount =
        fetchLoan?.groupCollection?.collectionAmount -
        fetchLoan?.groupCollection?.paidAmount;
      setFieldValue("collectionAmount", amount);
      setFieldValue("paidAmount", amount);
    } else {
      setFieldValue(
        "collectionAmount",
        fetchLoan?.groupCollection?.collectionAmount
      );
      setFieldValue("paidAmount", fetchLoan?.groupCollection?.collectionAmount);
    }

    console.log(formattedDueDate); // Ensure it's formatted properly
    setFieldValue("frequency", fetchLoan?.groupCollection?.groupId?.frequency);
    setFieldValue(
      "totalLoanAmount",
      fetchLoan?.groupCollection?.groupId?.loanAmount
    );
    setFieldValue("agentName", fetchLoan?.groupCollection?.agent?.userName);

    setFieldValue(
      "amountToBePaidBy",
      fetchLoan?.groupCollection?.groupId?.amountToBePaidBy
    );
    setFieldValue("dueDate", formattedDueDate);
    setFieldValue("interestAmount", fetchLoan?.groupCollection?.interestAmount);
    setFieldValue(
      "totalReceivedAmount",
      fetchLoan?.groupCollection?.groupId?.totalReceivedAmount
    );
    setFieldValue(
      "remainingAmount",
      fetchLoan?.groupCollection?.groupId?.remainingAmount
    );
    setFieldValue(
      "totalInterestPaid",
      fetchLoan?.groupCollection?.groupId?.totalInterestAmountPaid
    );
  };

  //   const handleAmountPaid = async (value) => {
  //     if (value === "interest") {
  //       return formik?.values?.interestAmount || 0;
  //     } else if (value === "interest+emi" || value === "emi") {
  //       return formik?.values?.collectionAmount;
  //     } else if (value === "penalty") {
  //       return loan?.penaltyAmount;
  //     }
  //   };

  useEffect(() => {
    if (formik.values.selectedUserData) {
      const total = formik.values.selectedUserData.reduce(
        (sum, user) => sum + (user.amount || 0),
        0
      );
      formik.setFieldValue("paidAmount", total);
    }
  }, [formik.values.selectedUserData]);

  return (
    <Paper sx={{ padding: 4 }}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2}>
          {/* Customer and Loan details section */}
          <Grid item xs={12} sm={12}>
            <Typography variant="body1" gutterBottom>
              Customer Name/Loan Code/Phone Number
            </Typography>
            <Autocomplete
              value={
                options?.find((option) => option?._id === formik.values.loan) ||
                null
              }
              onChange={(event, newValue) => {
                handleAutocompleteChange(event, newValue, formik.setFieldValue);
              }}
              onInputChange={(event, newInputValue) => {
                if (event && event.type === "change") {
                  debouncedFetchOptions(newInputValue);
                }
              }}
              options={options}
              getOptionLabel={(option) =>
                `${option?.groupName} (${option?.groupCode}) ` || ""
              }
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  error={Boolean(formik.touched.loan && formik.errors.loan)}
                  helperText={formik.touched.loan && formik.errors.loan}
                />
              )}
            />
          </Grid>

          {/* Agent Name */}
          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Agent Name</Typography>
            <TextField
              fullWidth
              name="agentName"
              value={formik.values.agentName}
              onChange={formik.handleChange}
              size="small"
              disabled={true}
            />
          </Grid>

          {/* Frequency */}
          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Frequency</Typography>
            <TextField
              fullWidth
              name="frequency"
              value={formik.values.frequency}
              onChange={formik.handleChange}
              size="small"
              disabled={true}
            />
          </Grid>

          {/* Loan Amount details */}
          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Total Loan Amount</Typography>
            <TextField
              fullWidth
              name="totalLoanAmount"
              value={formik.values.totalLoanAmount}
              onChange={formik.handleChange}
              size="small"
              disabled={true}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Total Received Amount</Typography>
            <TextField
              fullWidth
              name="totalReceivedAmount"
              value={formik.values.totalReceivedAmount}
              onChange={formik.handleChange}
              size="small"
              disabled={true}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Remaining Amount</Typography>
            <TextField
              fullWidth
              name="remainingAmount"
              value={formik.values.remainingAmount}
              onChange={formik.handleChange}
              size="small"
              disabled={true}
            />
          </Grid>

          {/* Collection and Interest Information */}
          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Collection Amount</Typography>
            <TextField
              fullWidth
              name="collectionAmount"
              disabled={true}
              value={formik.values.collectionAmount}
              onChange={formik.handleChange}
              size="small"
              error={Boolean(
                formik.touched.collectionAmount &&
                  formik.errors.collectionAmount
              )}
              helperText={
                formik.touched.collectionAmount &&
                formik.errors.collectionAmount
              }
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Interest Amount</Typography>
            <TextField
              fullWidth
              name="interestAmount"
              value={formik.values.interestAmount}
              onChange={formik.handleChange}
              size="small"
              disabled={true}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Total Interest Amount Paid</Typography>
            <TextField
              fullWidth
              name="totalInterestPaid"
              value={formik.values.totalInterestPaid}
              onChange={formik.handleChange}
              size="small"
              disabled={true}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Amount To Be Paid By</Typography>
            <TextField
              size="small"
              name="amountToBePaidBy"
              select
              fullWidth
              required
              variant="outlined"
              value={formik.values.amountToBePaidBy}
              onChange={async (e) => {
                formik.handleChange(e); // Make sure formik handles the field change
                // const amount = await handleAmountPaid(e.target.value); // Pass the selected value to handleAmountPaid
                //formik.setFieldValue("paidAmount", amount); // Set the calculated amount
              }}
            >
              {formik.values?.frequency === "monthly"
                ? [
                    <MenuItem key="interest" value="interest">
                      Interest
                    </MenuItem>,
                    <MenuItem key="emi" value="emi">
                      EMI
                    </MenuItem>,
                    <MenuItem key="interest+emi" value="interest+emi">
                      Interest + EMI
                    </MenuItem>,
                  ]
                : [
                    <MenuItem key="emi" value="emi">
                      EMI
                    </MenuItem>,
                    <MenuItem key="penalty" value="penalty">
                      Penalty
                    </MenuItem>,
                  ]}
            </TextField>
          </Grid>

          {/* Collection Date Field */}
          {/* Collection Date Field */}
          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Due Date</Typography>
            <TextField
              type="date"
              name="dueDate"
              value={formik.values.dueDate || ""}
              onChange={formik.handleChange}
              fullWidth
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Collection Date</Typography>
            <TextField
              type="date"
              value={formik.values.collectionDate || ""}
              onChange={(e) => {
                formik.setFieldValue("collectionDate", e.target.value);
              }}
              fullWidth
              size="small"
              error={
                formik.touched.collectionDate &&
                Boolean(formik.errors.collectionDate)
              }
              helperText={
                formik.touched.collectionDate && formik.errors.collectionDate
              }
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true, // Makes the field read-only
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Paid Amount</Typography>
            <TextField
              fullWidth
              name="paidAmount"
              value={formik.values.paidAmount}
              onChange={(e) => {
                formik.setFieldValue("paidAmount", e.target.value);
              }}
              size="small"
              error={Boolean(
                formik.touched.paidAmount && formik.errors.paidAmount
              )}
              InputProps={{
                readOnly: true, // Makes the field read-only
              }}
              helperText={formik.touched.paidAmount && formik.errors.paidAmount}
            />
          </Grid>

          {/* Submit Button */}
        </Grid>
        <Box sx={{ p: 3 }}>
          <Typography variant="h5" gutterBottom>
            User Collections
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={allSelected}
                onChange={handleSelectAllChange}
                indeterminate={
                  formik.values.selectedUserData.length > 0 &&
                  formik.values.selectedUserData.length < loans.length
                }
              />
            }
            label="Select All"
            sx={{ mb: 2 }}
            disabled={hasPaidLoan}
          />

          <Grid container spacing={3}>
            {loans.map((loan, index) => (
              <Grid item xs={3} sm={3} md={3} key={loan._id}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    p: 2,
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <Typography variant="h6">Collection {index + 1}</Typography>

                  <>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formik?.values?.selectedUserData.some(
                            (user) => user.id === loan.user?._id
                          )}
                          onChange={(event) => {
                            const isChecked = event.target.checked;
                            const selectedId = loan.user?._id;
                            const amountToBePaid = loan.collectionAmount;
                            const interestAmount = loan.interestAmount;

                            if (isChecked) {
                              // Add to selectedUserData
                              const newUserData = {
                                id: selectedId,
                                amountToBePaidType: "emi", // Default to "emi"
                                amount: amountToBePaid, // Default to the full amount
                                interestAmount: interestAmount,
                              };
                              const updatedData = [
                                ...formik?.values?.selectedUserData,
                                newUserData,
                              ];
                              formik.setFieldValue(
                                "selectedUserData",
                                updatedData
                              );
                            } else {
                              // Remove from selectedUserData
                              const updatedData =
                                formik.values?.selectedUserData?.filter(
                                  (user) => user.id !== selectedId
                                );
                              formik.setFieldValue(
                                "selectedUserData",
                                updatedData
                              );
                            }
                          }}
                        />
                      }
                      disabled={loan.status === "paid"}
                      label="Select User"
                    />
                  </>

                  <Chip
                    label={loan.status}
                    sx={{
                      bgcolor: loan.status === "paid" ? "green" : "red",
                      color: "#fff",
                    }}
                  />
                  <TextField
                    value={loan.user?.userName}
                    fullWidth
                    size="small"
                    InputProps={{ readOnly: true }}
                  />
                  <FormControl fullWidth size="small">
                    <Select
                      value={
                        formik.values?.selectedUserData?.find(
                          (user) => user.id === loan.user?._id
                        )?.amountToBePaidType || ""
                      }
                      onChange={(event) => {
                        const selectedType = event.target.value;
                        const selectedId = loan.user?._id;

                        const updatedData =
                          formik?.values?.selectedUserData?.map((user) => {
                            if (user.id === selectedId) {
                              const updatedAmount = calculateAmountBasedOnType(
                                loan,
                                selectedType
                              );
                              return {
                                ...user,
                                amountToBePaidType: selectedType,
                                amount: updatedAmount,
                              };
                            }
                            return user;
                          });
                        formik.setFieldValue("selectedUserData", updatedData);
                      }}
                    >
                      <MenuItem value="emi">EMI</MenuItem>
                      <MenuItem
                        value="penalty"
                        disabled={
                          groupCollection?.groupId?.frequency === "monthly"
                        }
                      >
                        Penalty
                      </MenuItem>
                      <MenuItem
                        value="interest"
                        disabled={
                          groupCollection?.groupId?.frequency === "weekly"
                        }
                      >
                        Interest
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    value={
                      formik?.values.selectedUserData
                        ?.find((user) => user.id === loan.user?._id)
                        ?.amount?.toFixed(2) || ""
                    }
                    fullWidth
                    size="small"
                    InputProps={{ readOnly: true }}
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
          {/* <Typography variant="h6" sx={{ mt: 3 }}>
            Selected Users: {selectedUsers.join(", ")}
          </Typography> */}
        </Box>
        <Grid item xs={12}>
          <Button
            type="submit"
            variant="contained"
            sx={{ borderRadius: "8px" }}
            // onClick={handleSubmit}
            disabled={isSubmit}
          >
            Submit
          </Button>
        </Grid>
      </form>
    </Paper>
  );
}

export default GroupCollection;
